import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { createContext, useContext, useState } from 'react';
// import axios from "axios";
// import { fetchLastTrackedMissions } from "../api/missions";

const GlobalContext = createContext();

export function GlobalContextProvider({ children }) {
    GlobalContextProvider.propTypes = {
        children: PropTypes.any,
    };

    //currently tracked mission
    const [mission, setMission] = useState({
        // "title": "mission de test",
        // "dateDebut": "2022-08-05T05:02:27.128Z",
        // "status": "normal",
        // "tasks": [],
        // "tracked": true,
        // "expertId": [
        //   {
        //     "personalData": {
        //       "firstname": "djnj",
        //       "lastname": "experdddstname",
        //       "email": "meriem.aitouaziz@gmail.com",
        //       "joinDate": "2022-08-10T05:18:37.474Z"
        //     },
        //     "company": {
        //       "name": "EMGS"
        //     }
        //   }
        // ]
    });

    useEffect(() => {
        // //  fetchLastTrackedMissions(setMission,1);
        // fetch = async (setLastTrackedMissions, number) => {
        //   await axios
        //     .get("http://localhost:8000/api/missions", {
        //       params: { number: number },
        //     })
        //     .then(
        //       async (res) => {
        //         console.log(res.data);
        //         if (number === 1) {
        //           await setLastTrackedMissions(res.data[0]);
        //           console.log(res.data[0]);
        //         } else {
        //           setLastTrackedMissions(res.data);
        //         }
        //       },
        //       (err) => {
        //         console.error("error in getting las  t tracked missions");
        //       }
        //     );
        // };
        // fetch(setMission, 1);
    }, []);
    // useEffect(() => {
    //   setMission(JSON.parse(window.localStorage.getItem("mission")));
    // }, []);

    // useEffect(() => {
    //   window.localStorage.setItem("mission", JSON.stringify(mission));
    //   console.log(JSON.parse(window.localStorage.getItem("mission")));
    // }, [mission]);

    return (
        <GlobalContext.Provider value={{ mission, setMission }}>
            {children}
        </GlobalContext.Provider>
    );
}

export const useGlobalContext = () => useContext(GlobalContext);
